export interface Cookie {
    readonly name: string,
    readonly value: string,
    readonly maxAge: number
}
export const setCookie = (cookie: Cookie) => {
    const cookieValue = `${cookie.name}=${encodeURIComponent(cookie.value)}; SameSite=strict; path=/; max-age=${cookie.maxAge}; Secure`
    document.cookie = cookieValue;
}
export const getCookie = (name: string) => {
    const cookieValue = document.cookie?.split(";").map(v => v.trim()).find((item) => item.startsWith(`${name}=`));
    if (!!cookieValue) {
        return cookieValue.split("=")[1];
    }
}